import Alpine from 'alpinejs';
import './styles/app.css';

window.Alpine = Alpine;

window.expenseSplit = function expenseSplit() {
  return {
    members: [],
    initialShares: {},
    init(members, shares) {
      this.members = Array.isArray(members) ? members : [];
      this.initialShares = shares || {};

      this.$nextTick(() => {
        this.members.forEach((member) => {
          const row = this.getRowElements(member.id);
          if (!row) return;

          const initial = Number(this.initialShares[member.id] ?? 0);
          if (initial > 0) {
            row.checkbox.checked = true;
            row.input.value = initial;
          }

          row.input.disabled = !row.checkbox.checked;
        });
      });
    },
    getRowElements(id) {
      if (!this.$refs.table) {
        return null;
      }

      const row = this.$refs.table.querySelector(`[data-member-row="${id}"]`);
      if (!row) {
        return null;
      }

      return {
        input: row.querySelector('[data-share-input]'),
        checkbox: row.querySelector('[data-share-checkbox]'),
      };
    },
    toggleAll(state) {
      this.members.forEach((member) => {
        const row = this.getRowElements(member.id);
        if (!row) return;

        row.checkbox.checked = state;
        row.input.disabled = !state;
        if (!state) {
          row.input.value = '';
        }
      });
    },
    splitEven(total) {
      const amount = Number(total || 0);
      if (amount <= 0) {
        return;
      }

      const selectedMembers = this.members.filter((member) => {
        const row = this.getRowElements(member.id);
        return row && row.checkbox.checked;
      });

      if (!selectedMembers.length) {
        return;
      }

      const baseShare = Math.floor(amount / selectedMembers.length);
      let remainder = amount - baseShare * selectedMembers.length;

      selectedMembers.forEach((member) => {
        const row = this.getRowElements(member.id);
        if (!row) return;

        let value = baseShare;
        if (remainder > 0) {
          value += 1;
          remainder -= 1;
        }

        row.checkbox.checked = true;
        row.input.disabled = false;
        row.input.value = value > 0 ? value : '';
      });
    },
    handleCheckbox(event, id) {
      const row = this.getRowElements(id);
      if (!row) {
        return;
      }

      const checked = event.target.checked;
      row.input.disabled = !checked;
      if (!checked) {
        row.input.value = '';
      }
    },
    totalFromInput() {
      const form = this.$root.closest('form');
      if (!form) {
        return 0;
      }
      const input = form.querySelector('input[name="total_amount"]');
      return input ? Number(input.value) || 0 : 0;
    },
  };
};

Alpine.start();

